import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsModalDiagramImportSqlEnabled, selectModalDiagramImportSqlData } from '../../../redux/main/main.selectors';
import { toggleDiagramImportSql } from '../../../redux/main/main.actions';


import Modal from '../Modal/Modal';

import './ModalDiagramImportSql.scss';


const contentMap = {
    sql: {
        name: 'Import SQL Code',
        desc: "We’d love to hear your thoughts!",
    },
    dbml: {
        name: 'Import DBML Code',
        desc: "We’d love to hear your thoughts!",
    },
};

function getModalContent(type) {
    if (['sql', 'dbml'].includes(type)) {
        return contentMap[type];
    }
    return contentMap['sql'];
}


export const ModalDiagramImportSql = () => {
    const isOpen = useSelector(selectIsModalDiagramImportSqlEnabled);

    const dispatch = useDispatch();

    const inputRef = useRef(null);
    const [content, setContent] = useState(null);

    const modalType = useSelector(selectModalDiagramImportSqlData);

    useEffect(() => {
        if (modalType) {
            const modalContent = getModalContent(modalType);
            setContent(modalContent);
        }
        return () => { };
    }, [modalType]);


    const [value, setValue] = useState('');

    const handleSave = () => {
        if (value) {
            // dispatch(sendSupportRequest(value));
            dispatch(toggleDiagramImportSql(null));
            setTimeout(() => {
                setValue('');
            }, 300);
        }
    };

    const handleCancel = () => {
        setTimeout(() => {
            setValue('');
        }, 300);
        dispatch(toggleDiagramImportSql(null));
    };

    const handleRender = () => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
        }
    };

    if (!content) return null;

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-import-sql`}
            onCancel={handleCancel}
            onShouldRender={handleRender}
        >
            <div className="modal-content-header">{content.name}</div>
            <div className="modal-content-body">
                <textarea
                    maxLength="20000"
                    ref={inputRef}
                    autoComplete="off"
                    autoFocus={(window.innerWidth >= 1000)}
                    spellCheck="false"
                    placeholder={content.desc}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                />
                <button
                    disabled={!value}
                    onClick={() => handleSave()}>Import</button>
            </div>
        </Modal>
    );
};

export default ModalDiagramImportSql;
